import React from 'react'
import { useTranslation } from 'react-i18next'

interface IHeading {
	title: any
}

const Heading = ({ title }: IHeading) => {
	const { t } = useTranslation()
	return (
		<div className="mb-4">
			<h5 className="top-title">{t(title)}</h5>
			<hr />
		</div>
	)
}

export default Heading
